
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    OCTDRIVING_ACTION,
    ALL_OCTDRIVING,
    ALL_OCTCLUBSHOT,
    ADD_OCTDRIVING,
    FETCH_OCTDRIVING,
    EDIT_OCTDRIVING,
    DELETE_OCTDRIVING,
    FETCH_OCTDRIVINGCHART,
    FETCH_DRIVINGSHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Course Driving Actions
 */

    export const allOCTDriving = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: OCTDRIVING_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getoncoursedriving', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTDRIVING, payload: alldata });
            });
        }        
    
    }

    export const studentOCTDriving = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:OCTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentoncoursedriving', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTDRIVING, payload: alldata }); 
            });
        
        }
    }

    export const allOCTDrClubShot = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: OCTDRIVING_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getoncoursedrclubshot', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTCLUBSHOT, payload: alldata });
            });
        }        
    
    }

    export const addOCTDriving = (data, sepmore) => {
        var id=data.target.student.value;
        var payload = {
            "totval": 1,
            "student_1": data.target.student.value,
            "sgdate": data.target.seldate.value,
            "shtot_1": sepmore,
        }
    
        for (let i = 0; i < sepmore; i++) {
    
            var distance = 'clubused_' + i;
            var distanceval = data.target[distance].value;
            var right = 'right_' + i;
            var rightval = data.target[right].value;
            var left = 'left_' + i;
            var leftval = data.target[left].value;
            // var searea='area_'+i;            
            // var seareaval=data.target[searea].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var short = 'fairway_' + i;
            var shortval = data.target[short].value;
            var long = 'missleft_' + i;
            var longval = data.target[long].value;
            var area = 'missright_' + i;
            var areaval = data.target[area].value;
            var sepopt = 'routine_' + i;
            var seoptval = data.target[sepopt].value;           
    
            var adval = i + 1;
            var distadd = 'clubusd_1_' + adval;
            var rightadd = 'right_1_' + adval;
            var leftadd = 'left_1_' + adval;
            var seareaadd = 'area_1_'+adval;
            var contadd = 'contact_1_'+adval;
            var shortadd = 'frhit_1_' + adval;
            var longadd = 'mislft_1_' + adval;
            var areaadd = 'misrgt_1_' + adval;
            var sepoptadd = 'routine_1_' + adval;
    
            payload[distadd] = distanceval;
            payload[rightadd] = rightval;
            payload[leftadd] = leftval;
            payload[seareaadd] = "";
            payload[contadd]= contactval;
            payload[shortadd] = shortval;            
            payload[longadd] = longval;
            payload[areaadd] = areaval;
            payload[sepoptadd] = seoptval;
    
        }

        return (dispatch) => {
            dispatch({ type: OCTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl + '/api/addoncoursedriving', payload, { headers: AuthHeader.header })
                .then(response => {
                    var resdata = response.data;
                    if (resdata.status === 1) {
                        studentOCTDriving(id, '', '')(dispatch);
                        fetchOnDrivingChart(id, '', '', '', '', '')(dispatch);
                        NotificationManager.success(resdata.message);
                        dispatch({ type: ADD_OCTDRIVING });
                    }
                    return Promise.resolve(resdata);
    
                });
    
        }
    }

    export const fetchOCTDriving = (id, date) => {

        var payload = {
            "id": id,
            "date": date
        }
        return (dispatch) => {
            dispatch({ type: OCTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl + '/api/getocddetails', payload, { headers: AuthHeader.header })
                .then(response => {
                    var resdata = response.data;
                    if (resdata.status === 1) {
                        dispatch({ type: FETCH_OCTDRIVING, payload: resdata.data });
                    }
                    return Promise.resolve(resdata);
    
                });
    
        }
    }

    export const editOCTDriving = (data, sepmore, olddate) => {
        var id=data.target.student.value;
        var payload = {
            "totval": 1,
            "student": data.target.student.value,
            "sgdate": data.target.seldate.value,
            "shtot_1": sepmore,
            "olddate": olddate,
        }
    
        for (let i = 0; i < sepmore; i++) {
    
            var distance = 'clubused_' + i;
            var distanceval = data.target[distance].value;
            var right = 'right_' + i;
            var rightval = data.target[right].value;
            var left = 'left_' + i;
            var leftval = data.target[left].value;
            // var searea='area_'+i;            
            // var seareaval=data.target[searea].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var short = 'fairway_' + i;
            var shortval = data.target[short].value;
            var long = 'missleft_' + i;
            var longval = data.target[long].value;
            var area = 'missright_' + i;
            var areaval = data.target[area].value;
            var sepopt = 'routine_' + i;
            var seoptval = data.target[sepopt].value;           
    
            var adval = i + 1;
            var distadd = 'clubusd_1_' + adval;
            var rightadd = 'right_1_' + adval;
            var leftadd = 'left_1_' + adval;
            var seareaadd = 'area_1_'+adval;
            var contadd = 'contact_1_'+adval;
            var shortadd = 'frhit_1_' + adval;
            var longadd = 'mislft_1_' + adval;
            var areaadd = 'misrgt_1_' + adval;
            var sepoptadd = 'routine_1_' + adval;
    
            payload[distadd] = distanceval;
            payload[rightadd] = rightval;
            payload[leftadd] = leftval;
            payload[seareaadd] = "";
            payload[contadd]= contactval;
            payload[shortadd] = shortval;            
            payload[longadd] = longval;
            payload[areaadd] = areaval;
            payload[sepoptadd] = seoptval;
    
        }

        return (dispatch) => {
            dispatch({ type: OCTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl + '/api/editoncoursedriving', payload, { headers: AuthHeader.header })
                .then(response => {
                    var resdata = response.data;
                    if (resdata.status === 1) {
                        studentOCTDriving(id, '', '')(dispatch);
                        fetchOnDrivingChart(id, '', '', '', '', '')(dispatch);
                        NotificationManager.success(resdata.message);
                        dispatch({ type: EDIT_OCTDRIVING });
                    }
                    return Promise.resolve(resdata);
    
                });
    
        }
    }

    export const deleteOCTDriving = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }        
        return (dispatch) => { 
            dispatch({ type:OCTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteoncoursedriving', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTDriving(id, '', '')(dispatch);
                    fetchOnDrivingChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_OCTDRIVING});                    
                }                
                
            });
        
        }
    }

    export const fetchOnDrivingChart = (id, start, end, contact, club, area) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "club":club,
            "area":area            
        }

        return (dispatch) => { 
            dispatch({ type:OCTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/ondrivingreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                var driving=resdata.driving;
                dispatch({ type: FETCH_OCTDRIVINGCHART, payload: driving}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchOnDrivingShotChart = (id, start, end, club, area, contact, val) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "area":area,
            "club":club,
            "section":val            
        }

        return (dispatch) => { 
            dispatch({ type:OCTDRIVING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/ondrivingshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_DRIVINGSHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }